import { JsonapiEntity, attribute, entity, meta } from 'jsonapi-transformers';

export const NO_LICENSE_URL = 'http://talisaspire.com/licenses/no-license';

@entity({ type: 'licenses' })
export class License extends JsonapiEntity<License> {
  @attribute() title: string;
  @attribute() image_url: string;
  @attribute() license_url: string;
  @attribute() is_display_link: boolean;
  @meta() is_tenant_default: boolean;

  get isNoLicenseLicense(): boolean {
    return this.license_url === NO_LICENSE_URL;
  }
}
